export const STATUS = ["A", "O", "I", "P"];
